import LabelLang from 'component/LabelLang/label-lang'

export default function OldBoss({ personalName , personalImg , date , translation , cond }) {
  return (
    cond ?
    <div className="old-boss mx-auto">
        <img 
            src={personalImg}
            className="rounded-2 mx-auto"
            alt="old-boss"
            loading="lazy"
        />
        <h6>
            <LabelLang
                id={'name'}
                defaultValue={personalName}
                translations={translation}
            />
        </h6>
        <span>{date}</span>
    </div>
    :
    <div className="col-sm-6 col-md-4 col-lg-3 col-xl">
        <div className="old-boss">
            <img 
                src={personalImg}
                className="img-fluid rounded-2"
                alt="old-boss"
                loading="lazy"
            />
            <h6>
                <LabelLang
                    id={'name'}
                    defaultValue={personalName}
                    translations={translation}
                />
            </h6>
            <span>{date}</span>
        </div>
    </div>
  )
}
